import BottomSheet from '@/shared/components/BottomSheet'
import NavigationListView from '@/shared/components/navigation/components/navigationList'
import Portal from '@/shared/components/Portal'

interface NavigationViewProps {
  parkinglotName: string
  isOpen: boolean
  onClose: () => void
  latitude: number
  longitude: number
  targetId?: string
}

function NavigationView({ parkinglotName, isOpen, onClose, latitude, longitude, targetId }: NavigationViewProps) {
  return (
    <Portal targetId={targetId}>
      <BottomSheet
        isOpen={isOpen}
        disabled={false}
        btnText="닫기"
        pyValue="py-0"
        className="body-1 h-[56px]"
        title="길안내를 실행할 앱을 선택해 주세요."
        onClick={onClose}
        bodyContent={
          <NavigationListView
            parkinglotName={parkinglotName}
            latitude={latitude}
            longitude={longitude}
            targetId={targetId}
          />
        }
      />
    </Portal>
  )
}

export default NavigationView
